import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55d6fa16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "div-progress-main" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = { id: "div-ellipsis" }
const _hoisted_4 = {
  key: 0,
  class: "lds-ellipsis"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_9 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { id: "div-progress-subframe" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = { key: 2 }
const _hoisted_14 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      id: "div-progress-frame",
      style: _normalizeStyle(_ctx.getStyle())
    }, [
      _createElementVNode("h3", {
        id: "progress-title-h3",
        innerHTML: _ctx.title
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        (!_ctx.button)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_9))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.text)
          ? (_openBlock(), _createElementBlock("b", {
              key: 0,
              innerHTML: _ctx.text
            }, null, 8, _hoisted_11))
          : _createCommentVNode("", true),
        (_ctx.subtext)
          ? (_openBlock(), _createElementBlock("p", {
              key: 1,
              innerHTML: _ctx.subtext
            }, null, 8, _hoisted_12))
          : _createCommentVNode("", true),
        (!_ctx.subtext && _ctx.store.getters.localeSelected)
          ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_ctx.store.getters.translate('generic-loading')), 1))
          : _createCommentVNode("", true),
        (_ctx.button)
          ? (_openBlock(), _createElementBlock("button", {
              key: 3,
              innerHTML: _ctx.button,
              id: "custom-progress-note-open-button",
              class: "buttonContinue",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openSigningPopup && _ctx.openSigningPopup(...args))),
              style: {"margin-bottom":"-20px"}
            }, null, 8, _hoisted_14))
          : _createCommentVNode("", true)
      ])
    ], 4)
  ]))
}